import { render, staticRenderFns } from "./SystemCommunications.vue?vue&type=template&id=18ce38f4&scoped=true"
import script from "./SystemCommunications.vue?vue&type=script&lang=js"
export * from "./SystemCommunications.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunications.vue?vue&type=style&index=0&id=18ce38f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce38f4",
  null
  
)

export default component.exports